import { AbstractService, ApiResponse, PaginatedResponse } from './core/AbstractService';
import { User } from './core/types';
import api from './core/api';

interface UserStats {
  total: number;
  active: number;
  newThisMonth: number;
  verified: number;
}

class UserService extends AbstractService<User> {
  constructor() {
    super('/admin/users');
  }

  /**
   * Get user statistics
   */
  async getStats(): Promise<ApiResponse<UserStats>> {
    const response = await api.get<ApiResponse<UserStats>>(
      `${this.basePath}/stats`
    );
    return response.data;
  }

  /**
   * Search users
   */
  async searchUsers(
    query: string,
    params?: URLSearchParams
  ): Promise<PaginatedResponse<User>> {
    const searchParams = params || new URLSearchParams();
    searchParams.set('q', query);

    const response = await api.get<PaginatedResponse<User>>(
      `${this.basePath}/search?${searchParams.toString()}`
    );
    return response.data;
  }
}

export const userService = new UserService();
export default userService;
